import { render, staticRenderFns } from "./BannersBlockCms.vue?vue&type=template&id=11c67b43&scoped=true&"
import script from "./BannersBlockCms.vue?vue&type=script&lang=js&"
export * from "./BannersBlockCms.vue?vue&type=script&lang=js&"
import style0 from "./BannersBlockCms.vue?vue&type=style&index=0&id=11c67b43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c67b43",
  null
  
)

export default component.exports